import React, { useState, useEffect } from 'react';
import { Button, Typography, IconButton, Tooltip } from "@material-ui/core";
import { faFileVideo, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { buildShapperPath } from "../../../helpers/Tools";

function VideoUploader({
                           onVideoSelected,
                           defaultValue = null,
                           onVideoRemoved = () => {},
                           label = "Video",
                           positionPreview = "above",
                           multiple = false
                       }) {
    const [videos, setVideos] = useState([]);

    useEffect(() => {
        if (defaultValue) {
            let defaults = multiple ? defaultValue : [defaultValue];
            //explode by ,

            if(typeof defaults === 'string') {
                defaults = defaults.split(',');
            } else if (!Array.isArray(defaults)) {
                defaults = [defaults];
            }

            console.log("defaultsdefaultsdefaults");
            console.log(defaults);

            const videoPaths = defaults.map(path => {
                const trimmedPath = path.trim();
                return trimmedPath ? buildShapperPath(trimmedPath) : null;
            }).filter(Boolean);
            setVideos(videoPaths);
            onVideoSelected(multiple ? videoPaths : videoPaths[0]);
        }
    }, [defaultValue]);

    const handleChange = (event) => {
        const MAX_MB = 10;

        const files = Array.from(event.target.files)
            .filter(f => f.type.startsWith("video/"))
            .filter(f => f.size <= MAX_MB * 1024 * 1024);

        if (files.length === 0) {
            alert(`Vidéo trop lourde (max ${MAX_MB}MB)`);
            return;
        }

        const videoUrls = files.map((file) => ({
            file,
            preview: URL.createObjectURL(file)
        }));

        const newVideos = multiple ? [...videos, ...videoUrls] : videoUrls;

        console.log("GLEP");
        console.log(newVideos);
        console.log(newVideos.map((i) => i.preview));

        //soit c'est une url soit c'est un fichier
        setVideos(newVideos.map(img => img.preview || img));
        onVideoSelected(multiple ? files : files[0]);
    };

    const handleRemove = (index) => {
        const newVideos = [...videos];
        newVideos.splice(index, 1);
        setVideos(newVideos);
        onVideoRemoved(index);
    };

    const renderPreviews = () => (

        videos.map((img, index) => (
            <div
                key={index}
                style={{ position: 'relative', display: 'inline-block', margin: 8 }}
            >
                <video
                    src={img}
                    alt={`Aperçu ${index}`}
                    style={{
                        width: '150px',
                        height: '150px',
                        borderRadius: 4,
                        objectFit: 'cover',
                        transition: 'transform 0.2s'
                    }}
                    onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                    onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                />
                <Tooltip title="Supprimer l'video">
                    <IconButton
                        onClick={() => handleRemove(index)}
                        color="secondary"
                        size="small"
                        style={{
                            position: 'absolute',
                            top: 4,
                            right: 4,
                            backgroundColor: 'rgba(255,255,255,0.7)',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} />
                    </IconButton>
                </Tooltip>
            </div>
        ))
    );

    return (
        <div>
            {videos.length > 0 && positionPreview === "above" && (
                <div style={{ marginTop: 16 }}>
                    <Typography variant="subtitle1">Aperçu :</Typography>
                    <div>{renderPreviews()}</div>
                </div>
            )}

            <input
                accept="video/*"
                id="upload-video"
                type="file"
                multiple={multiple}
                style={{ display: 'none' }}
                onChange={handleChange}
            />

            <label htmlFor="upload-video">
                <Button
                    variant="outlined"
                    color="primary"
                    component="span"
                    startIcon={<FontAwesomeIcon icon={faFileVideo} />}
                    style={{
                        padding: '10px 20px',
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontWeight: 500,
                        fontSize: '14px',
                        boxShadow: 'none'
                    }}
                >
                    {label || 'Ajouter une vidéo'}
                </Button>
            </label>

            {videos.length > 0 && positionPreview === "below" && (
                <div style={{ marginTop: 16 }}>
                    {renderPreviews()}
                </div>
            )}
        </div>
    );
}

export default VideoUploader;
